import React, { Fragment, useContext, useEffect, useState, memo } from "react";
import { format, addDays, addMonths } from 'date-fns';

import Graph from "../../common/Graph/Graph";
import { AppContext } from "../../../components/AppProvider";
import { AlertPopup, Container, DateLayer, openAlertPopup, openLayerFn, PeriodSetting } from "../../Layout";
import { SubMenu, SUBS } from "./Input";
import { Doctor } from "../../../resources/Assets";
import { PostApi1403, PostApi1406 } from "../../../modules/network/padoPost";
import { FullScreenBmi } from "../FullScreen";
import { userHabit } from "../../../modules/utils/UserHabit";
import { NativeAction } from "../../../modules/utils/HandleWs";

export default memo((props) => {
    const sub = SUBS[1];
    const {userinfo, cfg, phonecfg} = useContext(AppContext);

    const [periodType, setPeriodType] = useState(props.match.params.periodType);
    const [startDate, setStartDate] = useState(props.match.params.startDate && props.match.params.startDate);
    const [endDate, setEndDate] = useState(props.match.params.endDate && props.match.params.endDate);

    const [target, setTarget] = useState("Bmi");

    const [graph, setGraph] = useState([]);
    const [status, setStatus] = useState([]);

    let bmiArrList = [];
    let wghtArrList = [];

    // 골격근량
    let smmArrList = [];
    // 체지방량
    let bdftArrList = [];
    // 내장지방
    let vsrlftArrList = [];
    let dateCnt = 0;
    let attainmentCnt = 0;

    const request1403 = (userinfo, trgtWght, vrtnType) => {
        PostApi1403(userinfo, cfg, phonecfg, periodType, startDate, endDate, 1, 100)
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                for(let i=(res.result.length-1); i>=0; i--) {
                    if((res.result.length-1) == i) {
                        dateCnt = 1;
                    } else {
                        if(i >= 0 && res.result[i+1].bmiDate != res.result[i].bmiDate) {
                            dateCnt = dateCnt + 1;
                        }
                    }
                    bmiArrList.push(
                        {
                            "y": res.result[i].bmi
                            , "label": res.result[i].bmiDate.substring(4,6) + "." + res.result[i].bmiDate.substring(6,8) + " " + res.result[i].bmiTime.substring(0,2) + ":" + res.result[i].bmiTime.substring(2,4)
                        }
                    );
                    
                    wghtArrList.push(
                        {
                            "y": res.result[i].wght
                            , "label": res.result[i].bmiDate.substring(4,6) + "." + res.result[i].bmiDate.substring(6,8) + " " + res.result[i].bmiTime.substring(0,2) + ":" + res.result[i].bmiTime.substring(2,4)
                        }
                    );
                    
                    if(res.result[i].smm || res.result[i].smm != "") {
                        smmArrList.push(
                            {
                                "y":res.result[i].smm
                                , "label": res.result[i].bmiDate.substring(4,6) + "." + res.result[i].bmiDate.substring(6,8) + " " + res.result[i].bmiTime.substring(0,2) + ":" + res.result[i].bmiTime.substring(2,4)
                            }
                        )
                    }

                    if(res.result[i].bdft || res.result[i].bdft != "") {
                        bdftArrList.push(
                            {
                                "y":res.result[i].bdft
                                , "label": res.result[i].bmiDate.substring(4,6) + "." + res.result[i].bmiDate.substring(6,8) + " " + res.result[i].bmiTime.substring(0,2) + ":" + res.result[i].bmiTime.substring(2,4)
                            }
                        )
                    }
                    
                    if(res.result[i].vsrlft || res.result[i].vsrlft != "") {
                        vsrlftArrList.push(
                            {
                                "y":res.result[i].vsrlft
                                , "label": res.result[i].bmiDate.substring(4,6) + "." + res.result[i].bmiDate.substring(6,8)  + " " + res.result[i].bmiTime.substring(0,2) + ":" + res.result[i].bmiTime.substring(2,4)
                            }
                        )
                    }

                    if(vrtnType === "P") {
                        if(trgtWght <= res.result[i].wght) {
                            attainmentCnt = attainmentCnt+1;
                        }
                    } else {
                        if(trgtWght >= res.result[i].wght) {
                            attainmentCnt = attainmentCnt+1;
                        }
                    }
                }

                setGraph({
                    ...graph,
                    "trgtWght":trgtWght,
                    "bmi":bmiArrList,
                    "wght":wghtArrList,
                    "smm":smmArrList,
                    "bdft":bdftArrList,
                    "vsrlft":vsrlftArrList
                });

                setStatus({
                    ...status,
                    "avgPcnt":((attainmentCnt/res.result.length) * 100).toFixed(2),
                    "atmtCnt":attainmentCnt,
                    "cnt":dateCnt
                });
            } else if(res.resultMsg === 'LOGOUT') {
                // openAlertPopup("다른 기기에 로그인 되어있습니다.");
                openLayerFn($('.alert-layer-logout'));
            } else {
                console.log("### ERR");
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    const request1406 = (userinfo) => {
        PostApi1406(userinfo, cfg, phonecfg)
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                request1403(userinfo, res.result.trgtWght, res.result.vrtnType);
            } else if(res.resultMsg === 'LOGOUT') {
                // openAlertPopup("다른 기기에 로그인 되어있습니다.");
                openLayerFn($('.alert-layer-logout'));
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    const handleDate = (isStart, date) => {
        if (isStart === "1") {
            setStartDate(date);
        } else {
            setEndDate(date);
        }
    }

    useEffect(()=>{
        if(periodType === 4) {
            if(startDate != 1 && endDate != 1){
                request1406(userinfo);
            }
        } else {
            request1406(userinfo);
        }
    }, [periodType, startDate, endDate]);

    useEffect(()=>{
        userHabit(phonecfg, "BM121");
        
    }, [phonecfg.version]);

    return(
        <Fragment>
            <Container Title={sub.label} goToUrl="/sm">
                <div className="contents sub">
                    <SubMenu code={sub.code} />

                    <div className="sub-contents">
                        <div className="date-setting-area">
                            <PeriodSetting settingPeriodType={setPeriodType} periodType={periodType} startDate={startDate} endDate={endDate} />
                        </div>

                        <div className="doctor-massage-box">
                            <div className="dot-photo">
                                {
                                    status.avgPcnt >= 50
                                        ?   userinfo.sex == '1' 
                                            ? <img src={Doctor.male.good} alt="" /> 
                                            : <img src={Doctor.female.good} alt="" />
                                        :   userinfo.sex == '1' 
                                            ? <img src={Doctor.male.bad} alt="" /> 
                                            : <img src={Doctor.female.bad} alt="" />
                                }
                            </div>
                            {status &&
                                <p>
                                    ‘{userinfo.userName} 님’ {status.cnt}일 동안<br/>
                                    목표한 BMI 수치를 {status.atmtCnt}회 유지하였습니다.
                                </p>
                            }
                        </div>
                        
                        {graph.bmi && graph.bmi.length > 0 && graph.wght && graph.wght.length > 0
                            &&  <Graph title='체중&BMI 그래프' 
                                    rightTitle='몸무게 목록' 
                                    rightUrl={'/sm/bmi/list' + '/' + periodType + '/' + startDate + '/' + endDate} 
                                    graphTarget={"BMI"}
                                    graphData1={graph.trgtWght}
                                    graphData2={graph.bmi}
                                    graphData3={graph.wght}
                                    setTarget={setTarget}
                                />
                        }
                        
                        {graph.smm && graph.smm.length > 0 
                            &&  <Graph title='골격근량 그래프' graphTarget={"SMM"} graphData1={graph.smm} setTarget={setTarget} />
                        }

                        {graph.bdft && graph.bdft.length > 0
                            &&  <Graph title='체지방량 그래프' graphTarget={"BDFT"} graphData1={graph.bdft} setTarget={setTarget} />
                        }

                        {graph.vsrlft && graph.vsrlft.length > 0
                            &&  <Graph title='내장지방레벨 그래프' graphTarget={"VSRLFT"} graphData1={graph.vsrlft} setTarget={setTarget} />
                        }
                    </div>
                </div>
            </Container>
            <FullScreenBmi periodType={periodType} startDate={startDate} endDate={endDate} target={target} />
            <DateLayer handleDate={handleDate} color="green" />
            <AlertPopup />
        </Fragment>
    );
})